"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../../redux/reducers/account-reactivation/actions");
var styles = function (theme) {
    return (0, core_1.createStyles)({
        dialogActions: {
            padding: theme.spacing(2)
        },
        list: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
        },
        email: {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        button: {
            width: '272px',
            height: '44px'
        }
    });
};
var AccountReactivateDialog = function (_a) {
    var email = _a.email, show = _a.show, successCalback = _a.successCalback;
    var theme = (0, core_1.useTheme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var useStyles = (0, core_1.makeStyles)(styles);
    var classes = useStyles(theme);
    var dispatch = (0, react_redux_1.useDispatch)();
    var cancel = function () {
        dispatch((0, actions_1.reactivateAccount)(false));
    };
    var success = function () {
        dispatch((0, actions_1.reactivateAccount)(false));
        successCalback();
    };
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": "Account deactivation", open: show, className: 'po-widget-dialog' },
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.DialogTitle, { id: "alert-dialog-slide-title", disableTypography: true },
                react_1.default.createElement(core_1.Typography, { variant: "h6", id: "modal-title", align: 'center' }, t('account.deactivate.accountDeactivated'))),
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(core_1.Typography, { variant: "subtitle2", id: "modal-title", align: 'center' }, t('account.deactivate.deactivationReason')),
                react_1.default.createElement("ul", { className: classes.list },
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(core_1.Typography, { variant: "body2", align: 'center' }, t('account.deactivate.deactivationReason1'))),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(core_1.Typography, { variant: "body2", align: 'center' }, t('account.deactivate.deactivationReason2')))),
                react_1.default.createElement(core_1.Typography, { variant: "subtitle1", align: 'center' }, t('account.deactivate.toReactivate')),
                react_1.default.createElement(core_1.Typography, { variant: "body2", align: 'center' }, t('account.deactivate.reactivationInstructions')),
                react_1.default.createElement(core_1.Typography, { variant: "subtitle2", align: 'center', className: classes.email }, email),
                react_1.default.createElement(core_1.Typography, { variant: "body2", align: 'center' }, t('account.deactivate.cancelReactivation'))),
            react_1.default.createElement(core_1.Grid, { container: true, className: classes.dialogActions, direction: "column", alignItems: "center" },
                react_1.default.createElement(core_1.Button, { color: 'primary', size: 'small', variant: 'contained', onClick: success, className: classes.button }, t('account.deactivate.yesReactivate')),
                react_1.default.createElement(core_1.Button, { color: 'primary', size: 'small', variant: 'text', onClick: cancel, className: classes.button }, t('account.deactivate.cancel'))))));
};
exports.default = AccountReactivateDialog;
//# sourceMappingURL=AccountReactivateDialog.js.map